<template>
    <v-dialog v-model="contractAcceptanceState" width="300" persistent>
        <v-card color="">
            <v-toolbar dark color="#002EA7">
                <v-toolbar-title>Vielen Dank!</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="false" icon dark @click="reloadPage">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <p>
                    Vielen Dank, dass Sie sich für 4gewinnt der Öffentlichen entschieden
                    haben. Ihren Versicherungsschein erhalten Sie per E-Mail.
                </p>

                <p v-if="isOnlineGS">
                    <strong>Bestandsnummer:</strong><br />{{ salesAgentNr }}
                </p>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "ContractAcceptedMessage",
    data() {
        return {
            showSuccessMessage: true
        };
    },
    methods: {
        reloadPage() {
            this.$store.dispatch("work/postMessageReload");
            document.location.reload();
        },
        /* writeReloadCookie() {
            try {
                Vue.$cookies.set("preventMessageOnlineGS", "4g is reloaded.");
            } catch (error) {
                console.error(
                    "Reload-Cookie konnte nicht erstellt werden. Meldung: " + error
                );
            }
        } */
    },
    computed: {
        contractAcceptanceState() {
            // show this dialog, if contract is accepted an the user did not close it so far.
            return (
                this.showSuccessMessage &&
                this.$store.getters["work/getContractAcceptanceState"]
            );
        },
        isOnlineGS() {
            return this.$store.getters["work/getIsOnlineGs"];
        },
        ...mapGetters("work", {
            salesAgentNr: "getSalesAgentNr"
        })
    }
};
</script>

<style scoped></style>
